function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import exif from './exif';
export var parseMeta = function parseMeta(blob, cb) {
  var fr = new FileReader();

  fr.onload = function () {
    cb(parseHead(fr.result));
  };

  fr.onerror = function (e) {
    cb({});
  };

  blob = blob.slice(0, 262144);
  fr.readAsArrayBuffer(blob);
};
export var parseHead = function parseHead(buffer, noParse) {
  if (buffer.byteLength < 6) {
    return {};
  }

  var ret = {};
  var dataview = new DataView(buffer);
  var maxOffset = dataview.byteLength - 4;
  var offset = 2;
  var headLength = offset;

  if (dataview.getUint16(0) === 0xffd8) {
    while (offset < maxOffset) {
      var markerBytes = dataview.getUint16(offset);

      if (markerBytes >= 0xffe0 && markerBytes <= 0xffef || markerBytes === 0xfffe) {
        var markerLength = dataview.getUint16(offset + 2) + 2;

        if (offset + markerLength > dataview.byteLength) {
          break;
        }

        var PARSER_MAP = {
          0xffe1: [exif.parseExifData]
        };
        var parsers = PARSER_MAP[markerBytes];

        if (!noParse && parsers) {
          var _iterator = _createForOfIteratorHelper(parsers),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var fn = _step.value;
              fn(dataview, offset, markerLength, ret);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        offset += markerLength;
        headLength = offset;
      } else {
        break;
      }
    }

    if (headLength > 6) {
      ret.imageHead = buffer.slice ? buffer.slice(2, headLength) : new Uint8Array(buffer).subarray(2, headLength);
    }
  }

  return ret;
};
export var dataURL2ArrayBuffer = function dataURL2ArrayBuffer(dataURI) {
  var parts = dataURI.split(',');
  var byteStr = ~parts[0].indexOf('base64') ? atob(parts[1]) : decodeURIComponent(parts[1]);
  var ab = new ArrayBuffer(byteStr.length);
  var intArray = new Uint8Array(ab);

  for (var i = 0; i < byteStr.length; i++) {
    intArray[i] = byteStr.charCodeAt(i);
  }

  return intArray.buffer;
};
export var updateImageHead = function updateImageHead(buffer, head) {
  var data = parseHead(buffer, true);
  var bodyoffset = 2;

  if (data.imageHead) {
    bodyoffset = 2 + data.imageHead.byteLength;
  }

  var bodyBuffer = buffer.slice ? buffer.slice(bodyoffset) : new Uint8Array(buffer).subarray(bodyoffset);
  var resultBuffer = new Uint8Array(head.byteLength + 2 + bodyBuffer.byteLength);
  resultBuffer[0] = 0xff;
  resultBuffer[1] = 0xd8;
  resultBuffer.set(new Uint8Array(head), 2);
  resultBuffer.set(new Uint8Array(bodyBuffer), head.byteLength + 2);
  return resultBuffer.buffer;
};
export var arrayBufferToBlob = function arrayBufferToBlob(buffer, type) {
  return new Blob([buffer], type ? {
    type: type
  } : {});
};
export var dataURL2Blob = function dataURL2Blob(dataURI) {
  var parts = dataURI.split(',');
  var byteStr = ~parts[0].indexOf('base64') ? atob(parts[1]) : decodeURIComponent(parts[1]);
  var mimetype = parts[0].split(':')[1].split(';')[0];
  var ab = new ArrayBuffer(byteStr.length);
  var intArray = new Uint8Array(ab);

  for (var i = 0; i < byteStr.length; i++) {
    intArray[i] = byteStr.charCodeAt(i);
  }

  return arrayBufferToBlob(ab, mimetype);
};